import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChangelog = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.444 1.59784L13.1199 1.74509C12.0815 1.86052 11.1132 2.32595 10.3743 3.06483L4.3573 9.08186L6.95873 11.6845L12.977 5.66748C13.7161 4.92883 14.1816 3.96045 14.2967 2.92187L14.444 1.59784Z",
			stroke: "currentColor",
			strokeWidth: .981672,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.35728 9.08186L2.13502 8.34069C2.0606 8.31598 1.99374 8.27263 1.94081 8.21478C1.88788 8.15692 1.85063 8.08648 1.83261 8.01017C1.81459 7.93385 1.8164 7.85419 1.83787 7.77877C1.85933 7.70335 1.89974 7.63468 1.95525 7.57928L2.09759 7.43694C2.58097 6.95347 3.18944 6.61415 3.85481 6.45702C4.52018 6.29989 5.21616 6.33115 5.86476 6.5473L6.63476 6.80376L4.35728 9.08186Z",
			stroke: "currentColor",
			strokeWidth: .981672,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.95886 11.6845L7.70002 13.9068C7.72474 13.9812 7.76809 14.0481 7.82594 14.101C7.8838 14.1539 7.95423 14.1912 8.03055 14.2092C8.10687 14.2272 8.18653 14.2254 8.26195 14.2039C8.33737 14.1825 8.40604 14.142 8.46143 14.0865L8.60439 13.9442C9.08776 13.4608 9.42696 12.8523 9.58398 12.1869C9.741 11.5215 9.70964 10.8256 9.49342 10.177L9.23818 9.4101L6.95886 11.6845Z",
			stroke: "currentColor",
			strokeWidth: .981672,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.41197 12.0103C5.41221 12.1916 5.37661 12.3712 5.30722 12.5387C5.23784 12.7063 5.13603 12.8584 5.00765 12.9865C4.46896 13.5251 1.75586 14.2878 1.75586 14.2878C1.75586 14.2878 2.5185 11.5728 3.05719 11.036C3.29383 10.7988 3.60879 10.6559 3.94315 10.6341",
			stroke: "currentColor",
			strokeWidth: .981672,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgChangelog;
